module.exports = __webpack_public_path__ + "static/img/lenovoYOGATab3.e9fea811.png";